<template>

	<ao-btn
		class="app-sidebar-link"
		custom="referenceMaterialsLinksCustomBtn"
		variant="text"
		:to="to"
		:active="active"
		:disabled="disabled"
		:loading="loadedRouterLink === to.name"
	>
		<ao-icon
			v-if="icon"
			:iconName="icon"
			class="mr-1"
		/>
		<span>
			{{ title }}
		</span>
	</ao-btn>

</template>

<script setup>
defineProps({
	to: {
		type: Object,
		default: () => (null),
	},

	title: {
		type: String,
		default: '',
	},

	loadedRouterLink: {
		type: String,
		default: null,
	},

	icon: {
		type: String,
		default: null,
	},

	active: {
		type: Boolean,
	},

	disabled: {
		type: Boolean,
	},
})
</script>
